import {CopilotAvatar} from '@github-ui/copilot-avatar'
import {GitHubAvatar} from '@github-ui/github-avatar'
import {hovercardAttributesForActor} from '@github-ui/hovercards'
import {Link} from '@primer/react'
import {clsx} from 'clsx'

import assigneeStyles from './Assignee.module.css'
import styles from './Assignees.module.css'

type Props = {
  login: string
  avatarUrl: string
  isCopilot: boolean
  isAgent: boolean
  displayName?: string
  className?: string
  square?: boolean
  /**
   * Href getter for the assignee link
   * @param name - name of the assignee
   * @returns URL to the assignee
   */
  getAssigneeHref: (assignee: string) => string
}

export function Assignee({
  login,
  avatarUrl,
  isCopilot,
  isAgent,
  displayName: displayNameProp,
  getAssigneeHref,
  className,
  square = false,
}: Props) {
  const getDisplayName = () => {
    if (isCopilot) return 'Copilot'
    if (isAgent && displayNameProp) return displayNameProp
    return login
  }
  const displayName = getDisplayName()
  const hovercardAttributes = hovercardAttributesForActor(login, {isCopilot, isAgent})

  return (
    <Link
      aria-label={`${displayName} is assigned`}
      href={getAssigneeHref(isCopilot ? '@copilot' : login)}
      {...hovercardAttributes}
      /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
      className={clsx(className, 'pc-AvatarItem', styles.assigneeIconLink)}
    >
      {isCopilot ? (
        <CopilotAvatar key={login} size={'small'} className={square ? assigneeStyles.squareAvatar : undefined} />
      ) : (
        <GitHubAvatar
          key={login}
          alt={displayName}
          src={avatarUrl}
          square={square}
          className={clsx(assigneeStyles.AssigneeAvatar, square && assigneeStyles.squareAvatar)}
        />
      )}
    </Link>
  )
}
